// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__SoOVb","active":"NavigationItem_active__32VWy"};